module.exports = {
  insuranceLead: [
    "Advertisement",
    "Cold Call",
    "Employee Referral",
    "External Referral",
    "Online Store",
    "Partner",
    "Public Relations",
    "Sales Email Alias",
    "Seminar Partner",
    "Internal Seminar",
    "Trade Show",
    "Web Download",
    "chat",
  ],
  dealOwnerOptions: ["Existing Business", "New Business"],
  stage: [
    "Qualification",
    "Needs Analysis",
    "Value Proposition",
    "Identify Decision Makers",
    "Presentation",
    "Application",
    "Signature",
    "Underwriting",
    "Medical",
    "APS/ MIB",
    "Decision ( Approved/Denial/ PostPone/Rated)",
    "Accepted / Re-Apply/ Change Premium",
    "Delivery",
    "Convert Life",
  ],
  forecastCategory: ["Pipeline", "Best Case", "Committed"],
  type: ["Existing Business", "New Business"],
  currency: ["CAD", "USD"],
  objectType: ["-None-", "Yes", "No"],
  noList: ["-None-", "Yes Upto 4", "More than 4 to 6"],
  medicalNeeds: ["-None-", "Required", "Not required"],
  rating: ["-None-", "Approved with Rating", "Approved without Rating"],
  renewal: ["-None-", "Unknown", "Required", "Not Required"],
  claims: ["-None-", "Yes", "No", "Unkown"],
  approval: ["-None-", "Approved", "Rejected"],
};
